import {
  Box,
  Container,
  Typography,
  Grid,
  Card,
  CardContent,
  CardActions,
  Button,
} from '@mui/material';
import ViewWeekIcon from '@mui/icons-material/ViewWeek';
import ViewArrayIcon from '@mui/icons-material/ViewArray';
import ViewColumnIcon from '@mui/icons-material/ViewColumn';
import Inventory2Icon from '@mui/icons-material/Inventory2';
import { motion } from 'framer-motion';
import { Link as RouterLink } from 'react-router-dom';

const items = [
  {
    title: 'Single-Deep Selective Racking',
    desc: 'High accessibility, ideal for varied and fast-moving inventory.',
    icon: <ViewWeekIcon />,
  },
  {
    title: 'Double-Deep Selective Racking',
    desc: 'Greater storage density with cost-effective space utilization.',
    icon: <ViewArrayIcon />,
  },
  {
    title: 'Narrow/VNA Aisle Racks',
    desc: 'Maximize capacity with very narrow aisle configurations.',
    icon: <ViewColumnIcon />,
  },
  {
    title: 'Drive-in Pallet Racks',
    desc: 'High-density storage for uniform SKUs and deep lanes.',
    icon: <Inventory2Icon />,
  },
];

export default function Services() {
  return (
    <Box
      id="productindex"
      className="circuit-bg"
      sx={{
        py: { xs: 6, md: 8 },
        bgcolor: '#fcfcfc',
        overflowX: 'hidden',
      }}
    >
      <Container maxWidth="lg" sx={{ px: { xs: 2, sm: 3 } }}>
        <Box
          component={motion.div}
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <Typography
            variant="h3"
            sx={{ fontWeight: 800, mb: 1, textAlign: 'center', color: '#1a1a1a', fontSize: { xs: '1.65rem', sm: '2rem', md: '3rem' } }}
          >
            <Typography component="span" variant="h4" sx={{ color: '#ff6a00', mr: 1, fontWeight: 900 }}>
              Product
            </Typography>
            Categories
          </Typography>
          <Typography
            variant="h6"
            sx={{ mb: { xs: 4, md: 6 }, textAlign: 'center', color: '#555', maxWidth: 640, mx: 'auto', fontWeight: 500, fontSize: { xs: '0.95rem', md: '1.25rem' }, px: { xs: 1, sm: 0 } }}
          >
            Explore core racking lines — from selective to drive-in — tailored for how you store and pick.
          </Typography>
        </Box>
        <Grid container spacing={{ xs: 2, md: 4 }}>
          {items.map((it, index) => (
            <Grid item xs={12} sm={6} md={3} key={it.title}>
              <Box
                component={motion.div}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                sx={{ height: '100%' }}
              >
                <Card
                  sx={{
                    height: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    borderRadius: 0,
                    bgcolor: '#fff',
                    color: '#1a1a1a',
                    border: '1px solid rgba(0,0,0,0.05)',
                    boxShadow: '0 10px 30px rgba(0,0,0,0.05)',
                    transition: 'all 0.3s ease',
                    '&:hover': {
                      transform: 'translateY(-10px)',
                      borderColor: '#ff6a00',
                      boxShadow: '0 20px 40px rgba(0,0,0,0.1)',
                    },
                  }}
                >
                  <CardContent sx={{ flexGrow: 1, textAlign: 'center', pt: 4 }}>
                    <Box
                      sx={{
                        display: 'inline-flex',
                        p: 2,
                        borderRadius: '0',
                        bgcolor: 'rgba(255,106,0,0.05)',
                        color: '#ff6a00',
                        mb: 2,
                        '& svg': { fontSize: 40 },
                      }}
                    >
                      {it.icon}
                    </Box>
                    <Typography variant="h6" sx={{ fontWeight: 700, mb: 1 }}>
                      {it.title}
                    </Typography>
                    <Typography variant="body2" sx={{ color: '#555', lineHeight: 1.7 }}>
                      {it.desc}
                    </Typography>
                  </CardContent>
                  <CardActions sx={{ justifyContent: 'center', pb: 3 }}>
                    <Button
                      component={RouterLink}
                      to="/products"
                      size="small"
                      sx={{ fontWeight: 700, color: '#ff6a00' }}
                    >
                      View details
                    </Button>
                  </CardActions>
                </Card>
              </Box>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
}
